import { useState } from "react";
import { toast } from "sonner";
import { Download, Trash2, ShieldCheck } from "lucide-react";
import api from "@/lib/api";

export function DataRights() {
  const [busy, setBusy] = useState(false);
  const [confirming, setConfirming] = useState(false);
  const exportData = async () => {
    setBusy(true);
    try {
      const r = await api.get("/account/export", { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a"); a.href = url; a.download = "vectra-export.json"; a.click(); URL.revokeObjectURL(url);
      toast.success("Your data export has been downloaded");
    } catch (e) { toast.error(e?.response?.data?.detail || "Export failed"); }
    finally { setBusy(false); }
  };
  const requestDelete = async () => {
    setBusy(true);
    try {
      const r = await api.post("/account/delete-request");
      toast.success(r.data.message); setConfirming(false);
    } catch (e) { toast.error(e?.response?.data?.detail || "Request failed"); }
    finally { setBusy(false); }
  };
  return (
    <div data-testid="data-rights-card" className="glass rounded-2xl p-5">
      <div className="font-display font-semibold text-sm flex items-center gap-2"><ShieldCheck size={15} className="text-cyan-400" /> Your data</div>
      <p className="text-xs text-slate-500 mt-1">Export everything we hold about you, or ask us to delete your account. Media is removed within 30 days; payment records are kept 8 years for tax law.</p>
      <div className="flex flex-wrap gap-2 mt-3">
        <button data-testid="export-data-btn" disabled={busy} onClick={exportData} className="inline-flex items-center gap-1.5 text-xs px-3 py-2 rounded-full border border-white/15 hover:bg-white/5 disabled:opacity-50"><Download size={13} /> Export my data</button>
        {!confirming
          ? <button data-testid="delete-account-btn" disabled={busy} onClick={() => setConfirming(true)} className="inline-flex items-center gap-1.5 text-xs px-3 py-2 rounded-full border border-red-500/30 text-red-200 hover:bg-red-500/10 disabled:opacity-50"><Trash2 size={13} /> Delete my account</button>
          : <div className="flex items-center gap-2 text-xs"><span className="text-red-200">Delete account and all media?</span><button data-testid="delete-account-confirm" disabled={busy} onClick={requestDelete} className="px-3 py-1.5 rounded-full bg-red-500/20 border border-red-500/40 text-red-100">Yes, request deletion</button><button onClick={() => setConfirming(false)} className="text-slate-400">Cancel</button></div>}
      </div>
    </div>
  );
}
